module.exports = __webpack_public_path__ + "static/media/logo.8c7c83db.svg";